import CSQCAxios from '@/outils/CSQCAxios';

const CONTROLLER_NAME = 'DemandeContact';

export default {
  clearCache: false,
  envoyer(demande) {
    return CSQCAxios.getAxios().post(`${CONTROLLER_NAME}`, demande);
  },
};
